import React, { Fragment, useEffect, useState } from "react";
import {
  InputGroup,
  FormControl,
  Button,
  Table,
  Modal,
  Spinner,
  Badge,
} from "react-bootstrap";
import moment from "moment-timezone";
import { toast } from "react-toastify";
import { TextField } from "@mui/material";
import axios from "../axios";
import Restricted from "../components/restricted";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const Haih = ({ token }) => {
  const [tasksData, setTasksData] = useState([]);
  const [archiveData, setArchiveData] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [deleteId, setDeleteId] = useState(null);
  const [pagination, setPagination] = useState([]);
  const [loading, setLoading] = useState(false);
  const [changeItems, setChangeItems] = useState(0);
  const [totalPayment, setTotalPayment] = useState(0);

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [page, setPage] = useState(1);
  const limit = 8;
  const archiveLimit = 1000000;

  const [start, setStart] = useState(
    moment()
      .tz("Asia/Ulaanbaatar")
      .subtract(2, "months")
      .startOf("month")
      .format("YYYY-MM-DD")
  );
  const [end, setEnd] = useState(
    moment().tz("Asia/Ulaanbaatar").endOf("month").format("YYYY-MM-DD")
  );

  // Format number with commas
  const formatNumber = (num) => {
    if (!num && num !== 0) return "0";
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  useEffect(() => {
    const fetchTasksData = async () => {
      setLoading(true);

      const token = localStorage.getItem("salon");

      try {
        const result = await axios.get(
          `tasks?search=${inputValue}&page=${page}&limit=${limit}&start=${start}&end=${end}&sort=-date`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        setTasksData(result.data.data);
        setPagination(result.data.pagination);

        // Calculate total payment for current page
        const sum = result.data.data.reduce((acc, task) => {
          return acc + (Number(task.payment) || 0);
        }, 0);
        setTotalPayment(sum);
      } catch (error) {
        toast.error(
          `Алдаа: ${error.response?.data?.error?.message || error.message}`
        );
      } finally {
        setLoading(false);
      }
    };

    if (localStorage.getItem("salon")) {
      fetchTasksData();
    } else {
      setTasksData([]);
    }
  }, [inputValue, page, limit, token, changeItems, start, end]);

  useEffect(() => {
    const fetchArchiveData = async () => {
      setLoading(true);

      const token = localStorage.getItem("salon");

      try {
        const result = await axios.get(
          `tasks?search=${inputValue}&page=${page}&limit=${archiveLimit}&start=${start}&end=${end}&sort=-date`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        setArchiveData(result.data.data);
      } catch (error) {
        toast.error(
          `Алдаа: ${error.response?.data?.error?.message || error.message}`
        );
      } finally {
        setLoading(false);
      }
    };

    if (localStorage.getItem("salon")) {
      fetchArchiveData();
    } else {
      setArchiveData([]);
    }
  }, [inputValue, page, limit, token, changeItems, start, end]);

  const deleteHandler = async () => {
    const token = localStorage.getItem("salon");

    try {
      await axios.delete(`tasks/${deleteId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setChangeItems(changeItems + 1);
      toast.success(`Амжилттай устгалаа`);
    } catch (error) {
      toast.error(
        `Алдаа: ${error.response?.data?.error?.message || error.message}`
      );
    }
  };

  function onSearchHandle(event) {
    setInputValue(event.target.value);
  }

  const nextPage = () => {
    if (Math.ceil(pagination.total / limit) > page) setPage(page + 1);
  };

  const prevPage = () => {
    if (page > 1) setPage(page - 1);
  };

  const startPage = () => {
    setPage(1);
  };

  const exportToExcel = () => {
    // Calculate total for export
    const totalSum = archiveData.reduce((acc, task) => {
      return acc + (Number(task.payment) || 0);
    }, 0);

    // Prepare data for export
    const exportData = archiveData.map((task) => ({
      Огноо: task.date
        ? moment
            .utc(task.date)
            .tz("Asia/Ulaanbaatar")
            .format("YYYY-MM-DD HH:mm")
        : "",
      Үйлчлүүлэгч: task.customer || "",
      Ажилтан: task.employee?.name || "------------",
      Ирсэн: task.arrived || "",
      Төлбөр: Number(task.payment) || 0,
      Тэмдэглэл: task.note || "",
    }));

    // Add total row
    exportData.push({
      Огноо: "",
      Үйлчлүүлэгч: "",
      Ажилтан: "",
      Ирсэн: "НИЙТ:",
      Төлбөр: totalSum,
      Тэмдэглэл: "",
    });

    // Create worksheet
    const ws = XLSX.utils.json_to_sheet(exportData);

    // Create workbook
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Tasks");

    // Generate Excel file
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });

    // Save file with timestamp
    const fileName = `salon-data-${moment()
      .utc()
      .tz("Asia/Ulaanbaatar")
      .format("YYYY-MM-DD")}.xlsx`;
    const data = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(data, fileName);

    toast.success(`Нийт төлбөр: ${formatNumber(totalSum)}₮`);
  };

  const paginationBasic = (
    <div>
      <div className="paginationsButtonsHaih">
        <Button
          className="paginationStart"
          variant="outline-secondary"
          onClick={() => startPage()}
        >
          Эхний хуудас
        </Button>
        <Button
          className="paginationNext"
          variant="outline-secondary"
          onClick={() => prevPage()}
        >
          Өмнөх
        </Button>
        <span className="paginationPageNumber">
          {" Хуудас " + page + "/" + Math.ceil(pagination.total / limit)}
        </span>
        <Button
          className="paginationPrev"
          variant="outline-secondary"
          onClick={() => nextPage()}
        >
          Дараах
        </Button>
      </div>
      <div className="filterDate">
        <TextField
          id="datetime-start"
          type="date"
          defaultValue={start.slice(0, 10)}
          name="date"
          onChange={startHandler}
          InputLabelProps={{
            shrink: true,
          }}
        />
        <TextField
          id="datetime-end"
          type="date"
          defaultValue={end.slice(0, 10)}
          name="date"
          onChange={endHandler}
          InputLabelProps={{
            shrink: true,
          }}
        />
      </div>
      <div className="mt-3 mb-3">
        <Badge bg="info" style={{ fontSize: "16px", padding: "10px" }}>
          Хуудасны нийт төлбөр: {formatNumber(totalPayment)}₮
        </Badge>{" "}
        <Badge bg="success" style={{ fontSize: "16px", padding: "10px" }}>
          Бүх төлбөр:{" "}
          {formatNumber(
            archiveData.reduce(
              (acc, task) => acc + (Number(task.payment) || 0),
              0
            )
          )}
          ₮
        </Badge>
      </div>
      <Button variant="primary" onClick={exportToExcel}>
        Бүх дата-г татаж авах
      </Button>
    </div>
  );

  function endHandler(e) {
    setEnd(e.target.value);
  }

  function startHandler(e) {
    setStart(e.target.value);
  }

  return (
    <Fragment>
      {localStorage.getItem("salon") ? (
        <div className="mt-3">
          <InputGroup
            onChangeCapture={onSearchHandle}
            className="mb-3"
            size="md"
          >
            <FormControl placeholder="Хайх үгээ энд оруулна уу..." />
            <Button variant="primary">Хайх</Button>
          </InputGroup>
          {paginationBasic}
          {loading && (
            <div>
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            </div>
          )}
          <div className="flex overflow-hidden overflow-x-auto">
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>Огноо</th>
                  <th>Үйлчлүүлэгч</th>
                  <th style={{ whiteSpace: "nowrap" }}>Х/Ажилтан</th>
                  <th>Ирсэн</th>
                  <th>Төлбөр</th>
                  <th>Тэмдэглэл</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {tasksData &&
                  tasksData.map((task) => (
                    <tr key={task._id}>
                      <td style={{ minWidth: "160px" }}>
                        {task.date
                          ? moment
                              .utc(task.date)
                              .tz("Asia/Ulaanbaatar")
                              .format("YYYY-MM-DD HH:mm")
                          : ""}
                      </td>
                      <td>{task.customer}</td>
                      <td>{task.employee?.name || ""}</td>
                      <td>{task.arrived}</td>
                      <td>{formatNumber(task.payment)}₮</td>
                      <td>{task.note}</td>
                      <td>
                        <div className="hailtUstgahBtns">
                          <Button
                            variant="danger"
                            onClick={() => {
                              setDeleteId(task._id);
                              handleShow();
                            }}
                          >
                            Устгах
                          </Button>
                        </div>
                      </td>
                    </tr>
                  ))}
                <tr style={{ fontWeight: "bold", backgroundColor: "#f0f0f0" }}>
                  <td colSpan="4" style={{ textAlign: "right" }}>
                    Хуудасны нийт:
                  </td>
                  <td>{formatNumber(totalPayment)}₮</td>
                  <td colSpan="2"></td>
                </tr>
              </tbody>
            </Table>
          </div>

          <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
              <Modal.Title>Бүртгэл устгах</Modal.Title>
            </Modal.Header>
            <Modal.Body>Бүртгэлийг устгахдаа итгэлтэй байна уу?</Modal.Body>
            <Modal.Footer>
              <Button
                variant="danger"
                onClick={() => {
                  deleteHandler();
                  handleClose();
                }}
              >
                Устгах
              </Button>
              <Button variant="outline-secondary" onClick={handleClose}>
                Болих
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      ) : (
        <Restricted />
      )}
    </Fragment>
  );
};

export default Haih;
